/** Stable series for the desktop temperature chart. Same-day readings stay unique. */
export function temperatureHistoryPoints(readings = []) {
  const rows = Array.isArray(readings) ? readings : [];
  const points = [];
  for (let index = 0; index < rows.length; index++) {
    const row = rows[index];
    const temp = Number(row?.temperature);
    const at = Date.parse(row?.recorded_at);
    if (!Number.isFinite(temp) || !Number.isFinite(at)) continue;
    const date = new Date(at);
    points.push({
      id: row.id ?? index,
      temp,
      at,
      date: date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
      time: date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }),
      location: row.probe_location ?? null,
    });
  }
  const dateCounts = new Map();
  for (const point of points) dateCounts.set(point.date, (dateCounts.get(point.date) || 0) + 1);
  return points.map((point) => ({
    ...point,
    tick: dateCounts.get(point.date) > 1 ? `${point.date} ${point.time}` : point.date,
  }));
}

export function temperatureHistoryDomain(points) {
  if (!points.length) return ['dataMin', 'dataMax'];
  const times = points.map((point) => point.at);
  const min = Math.min(...times);
  const max = Math.max(...times);
  if (min === max) return [min - 36e5, max + 36e5];
  return [min, max];
}
